import {countries} from '../core/countries'
import {currencies} from '../core/currencies'

export enum GTMEvent {
  PageView = 'Page View',
  PageLoad = 'page_load',
  SignupInitiatedSuccessful = 'signup_initiated_successful',
  SignupInitiatedFailed = 'signup_initiated_failed',
  SignupSuccess = 'signup_successful',
  SignupFailed = 'signup_failed',
  LoginSuccess = 'login_successful',
  LoginFailed = 'login_failed',
  LogoutSuccess = 'logout_successful',
  LogoutFailed = 'logout_failed',
  OnboardingInitiatedSuccessful = 'onboarding_initiated_successful',
  OnboardingInitiatedFailed = 'onboarding_initiated_failed',
  OnboardingCompletedSuccessful = 'onboarding_completed_successful',
  OnboardingCompletedFailed = 'onboarding_completed_failed',
  OnboardingCompanyDetailsFilled = 'company_info_submitted_successful',
  OnboardingCompanyDetailsFilledFailed = 'company_info_submitted_failed',
  OnboardingRoundDetailsFilled = 'round_info_submitted_successful',
  OnboardingRoundDetailsFilledFailed = 'round_info_submitted_failed',
  DashboardViewSuccessful = 'dashboard_view_successful',
  DashboardViewFailed = 'dashboard_view_failed',
  NewCompanyCreationInitiatedSuccessful = 'new_company_creation_initiated_successful',
  NewCompanyCreationInitiatedFailed = 'new_company_creation_initiated_failed',
  NewCompanyCreationCompletedSuccessful = 'new_company_creation_completed_successful',
  NewCompanyCreationCompletedFailed = 'new_company_creation_completed_failed',
  EmailVerificationSuccess = 'email_verification_successful',
  EmailVerificationFailed = 'email_verification_failed',
  EmailVerificationStartSuccessful = 'email_verification_start_successful',
  PaywallShownSuccessful = 'paywall_shown_successful',
  PaymentPortalOpenedSuccessful = 'payment_portal_opened_successful',
  PaymentPortalOpenedFailed = 'payment_portal_opened_failed',
  CompanyPlanChangedSuccessful = 'company_plan_changed_successful',
  CompanyPlanChangedFailed = 'company_plan_changed_failed',
  CompanySwitchSuccessful = 'company_switch_successful',
  CompanySwitchFailed = 'company_switch_failed',
  ResourceDownloadSuccessful = 'resource_download_successful',
  ResourceDownloadFailed = 'resource_download_failed',

  ChargebeePortalWidgetOpened = 'chargebee_portal_widget_opened',
  ChargebeePortalWidgetClosed = 'chargebee_portal_widget_closed',
  BillingAddressChangedSuccessful = 'billing_address_changed_successful',
  PaymentMethodChangedSuccessful = 'payment_method_changed_successful',
  BillingInvoiceDownloadedSuccessful = 'billing_invoice_downloaded_successful',
  BillingInvoiceDownloadedFailed = 'billing_invoice_downloaded_failed',
  CompanySettingsUpdatedSuccessful = 'company_settings_updated_successful',
  CompanySettingsUpdatedFailed = 'company_settings_updated_failed',
  UserSettingsUpdatedSuccessful = 'user_settings_updated_successful',
  UserSettingsUpdatedFailed = 'user_settings_updated_failed',

  DigitalSigningTemplateCreatedSuccessful = 'digital_signing_template_created_successful',
  DigitalSigningTemplateCreatedFailed = 'digital_signing_template_created_failed',
  DigitalSigningDocumentCreatedSuccessful = 'digital_signing_document_created_successful',
  DigitalSigningDocumentCreatedFailed = 'digital_signing_document_created_failed',
  DigitalSigningDocumentSignedSuccessful = 'digital_signing_document_signed_successful',
  DigitalSigningDocumentSignedFailed = 'digital_signing_document_signed_failed',
  DigitalSigningDocumentDownloadedSuccessful = 'digital_signing_document_downloaded_successful',
  DigitalSigningDocumentDownloadedFailed = 'digital_signing_document_downloaded_failed',
  DigitalSigningDocumentViewedSuccessful = 'digital_signing_document_viewed_successful',
  CompanySwitchInitiatedSuccessful = 'company_switch_initiated_successful',
  CompanySwitchInitiatedFailed = 'company_switch_initiated_failed',
  CompanySwitchCompletedFailed = 'company_switch_completed_failed',
  CompanySwitchCompletedSuccessful = 'company_switch_completed_successful',
  UpdateChatThreadTitleSuccessful = 'update_chat_thread_title_successful',
  UpdateChatThreadTitleFailed = 'update_chat_thread_title_failed',
  DeleteChatThreadSuccessful = 'delete_chat_thread_successful',
  DeleteChatThreadFailed = 'delete_chat_thread_failed',
  AddChatThreadSuccessful = 'add_chat_thread_successful',
  AddChatThreadFailed = 'add_chat_thread_failed',
  UpdateBoardAdvisorsSuccessful = 'advisors_mentors_updation_successful',
  UpdateBoardAdvisorsFailed = 'advisors_mentors_updation_failed',
  AddBoardAdvisorsSuccessful = 'advisors_mentors_creation_successful',
  AddBoardAdvisorsFailed = 'advisors_mentors_creation_failed',
  UpdateCompanyProfileSuccessful = 'update_company_profile_successful',
  UpdateCompanyProfileFailed = 'update_company_profile_failed',
  UpdateIndustryFocusSuccessful = 'update_industry_focus_successful',
  UpdateIndustryFocusFailed = 'update_industry_focus_failed',
  UpdateInvestmentSuccessful = 'update_investment_successful',
  UpdateInvestmentFailed = 'update_investment_failed',
  AddInvestmentSuccessful = 'add_investment_successful',
  AddInvestmentFailed = 'add_investment_failed',
  DeleteInvestmentSuccessful = 'delete_investment_successful',
  DeleteInvestmentFailed = 'delete_investment_failed',
  UpdateInvestersSuccessful = 'update_investers_successful',
  UpdateInvestersFailed = 'update_investers_failed',
  AddInvestersSuccess = 'add_investers_success',
  AddInvestersFailed = 'add_investers_failed',
  DeleteInvestorsSuccessful = 'delete_investors_successful',
  DeleteInvestorsFailed = 'delete_investors_failed',
  UpdatePeopleSuccessful = 'update_people_successful',
  UpdatePeopleFailed = 'update_people_failed',
  AddPeopleSuccessful = 'add_people_successful',
  AddPeopleFailed = 'add_people_failed',
  DeletePeopleSuccessful = 'delete_people_successful',
  DeletePeopleFailed = 'delete_people_failed',
  DeleteBoardAdvisorsSuccessful = 'advisors_mentors_deletion_successful',
  DeleteBoardAdvisorsFailed = 'advisors_mentors_deletion_failed',
  UpdateCompanyPublishStatusSuccessful = 'update_company_publish_status_successful',
  UpdateCompanyPublishStatusFailed = 'update_company_publish_status_failed',
  EditDataRoomStatusSuccessful = 'edit_dataroom_status_successful',
  EditDataRoomStatusFailed = 'edit_dataroom_status_failed',
  DeleteDataRoomSuccessful = 'delete_dataroom_successful',
  DeleteDataRoomFailed = 'delete_dataroom_failed',
  DeleteDataRoomFolderContentSuccessful = 'delete_dataroom_folder_content_successful',
  DeleteDataRoomFolderContentFailed = 'delete_dataroom_folder_content_failed',
  UpdateDataRoomFolderContentNameSuccessful = 'update_dataroom_folder_content_name_successful',
  UpdateDataRoomFolderContentNameFailed = 'update_dataroom_folder_content_name_failed',
  DownloadDataRoomZipFileSuccessful = 'download_dataroom_zip_file_successful',
  DownloadDataRoomZipFileFailed = 'download_dataroom_zip_file_failed',
  DownloadDataRoomSignedFileSuccessful = 'download_dataroom_signed_file_successful',
  UpdateShareLinkStatusFailed = 'update_share_link_status_failed',
  UpdateShareLinkStatusSuccessful = 'update_share_link_status_successful',
  DeleteDataRoomContentSuccessful = 'delete_dataroom_content_successful',
  DeleteDataRoomContentFailed = 'delete_dataroom_content_failed',
  DataRoomContentIsHiddenSuccessful = 'dataroom_content_is_hidden_successful',
  DataRoomContentIsHiddenFailed = 'dataroom_content_is_hidden_failed',
  DataRoomContentTrashFailed = 'dataroom_content_trash_failed',
  DataRoomContentTrashSuccessful = 'dataroom_content_trash_successful',
  CreateShareLinkSuccessful = 'create_share_link_successful',
  CreateShareLinkFailed = 'create_share_link_failed',
  CreateShareLinkFileSuccessful = 'create_share_link_file_successful',
  CreateShareLinkFileFailed = 'create_share_link_file_failed',
  ContentCopiedDataroomSuccessful = 'content_copied_dataroom_successful',
  ContentCopiedDataroomFailed = 'content_copied_dataroom_failed',
  MoveFileToFolderFailed = 'move_file_to_folder_failed',
  MoveFileToFolderSuccessful = 'move_file_to_folder_successful',
  DataRoomImportCSVFailed = 'dataroom_import_csv_failed',
  DataRoomImportCSVSuccessful = 'dataroom_import_csv_successful',
  DataRoomDownloadCSVFileFailed = 'dataroom_download_csv_file_failed',
  DataRoomDownloadCSVFileSuccessful = 'dataroom_download_csv_file_successful',
  DeleteShareLinkSuccessful = 'delete_share_link_successful',
  DeleteShareLinkFailed = 'delete_share_link_failed',
  AddMoreFilesToPublicUrlSuccessful = 'add_more_files_to_public_url_successful',
  AddMoreFilesToPublicUrlFailed = 'add_more_files_to_public_url_failed',
  DataRoomAddMoreFilesContentSuccessful = 'dataroom_add_more_files_content_successful',
  DataRoomAddMoreFilesContentFailed = 'dataroom_add_more_files_content_failed',
  UploadFileToDataRoomSuccessful = 'upload_file_to_dataroom_successful',
  UploadFileToDataRoomFailed = 'upload_file_to_dataroom_failed',
  UploadFileToDataRoomUploadsUrlSuccessful = 'upload_file_to_dataroom_uploads_url_successful',
  UploadFileToDataRoomUploadsUrlFailed = 'upload_file_to_dataroom_uploads_url_failed',
  ContentPreviewSuccessful = 'content_preview_successful',
  ContentTimeSpendCreatedSuccessful = 'content_timespend_created_successful',
  ContentTimeSpendCreatedFailed = 'content_timespend_created_failed',
  DownloadSignedFileForContentSuccessful = 'download_signed_file_for_content_successful',
  DataRoomPreviewSuccessful = 'dataroom_preview_successful',
  OpenFolderDataroomShareLinkSuccessful = 'open_folder_dataroom_share_link_successful',
  UpdateDataRoomSuccessful = 'update_dataroom_successful',
  UpdateDataRoomFailed = 'update_dataroom_failed',
  CreateDataRoomSuccessful = 'create_dataroom_successful',
  CreateDataRoomFailed = 'create_dataroom_failed',
  DataRoomAddFolderSuccessful = 'dataroom_add_folder_successful',
  DataRoomAddFolderFailed = 'dataroom_add_folder_failed',
  FilePreviewSuccessful = 'file_preview_successful',
  ViewPubicFileDataRoomSuccessful = 'view_pubic_file_dataroom_successful',
  ViewPubicFileDataRoomFailed = 'view_pubic_file_dataroom_failed',
  FileVisitedDataRoomSuccessful = 'file_visited_dataroom_successful',
  FileVisitedDataRoomFailed = 'file_visited_dataroom_failed',
  FileTimeSpendDataRoomSuccessful = 'file_time_spend_dataroom_successful',
  FileTimeSpendDataRoomFailed = 'file_time_spend_dataroom_failed',
  DataRoomClonedSuccessful = 'dataroom_cloned_successful',
  DataRoomClonedFailed = 'dataroom_cloned_failed',
  DigitalSigningDocumentDeleted = 'digital_signing_document_deleted',
  DigitalSigningDocumentDeleteFailed = 'digital_signing_document_delete_failed',
  DigitalSigningTemplateDublicateSuccessful = 'digital_signing_template_dublicate_successful',
  DigitalSigningTemplateDublicateFailed = 'digital_signing_template_dublicate_failed',
  DigitalSigningDocumentSignatureEmailResend = 'digital_signing_document_signature_email_resend',
  DigitalSigningDocumentSignatureEmailResendFailed = 'digital_signing_document_signature_email_resend_failed',
  DigitalSigningTemplateExported = 'digital_signing_template_exported',
  DigitalSigningTemplateExportFailed = 'digital_signing_template_export_failed',
  DigitalSigningDocumentExported = 'digital_signing_document_exported',
  DigitalSigningDocumentExportFailed = 'digital_signing_document_export_failed',
  DigitalSigningTemplateUpdated = 'digital_signing_template_updated',
  DigitalSigningTemplateUpdateFailed = 'digital_signing_template_updated_failed',
  DigitalSigningTemplateViewedSuccessful = 'digital_signing_template_viewed_successful',
  DigitalSigningTemplateDeleteSuccessful = 'digital_signing_template_delete_successful',
  DigitalSigningTemplateDeleteFailed = 'digital_signing_template_delete_failed',
  FounderMarketBookmarked = 'founder_market_bookmarked',
  FounderMarketBookmarkFailed = 'founder_market_bookmark_failed',
  FounderMarketDealClaimed = 'founder_market_deal_claimed',
  FounderMarketDealClaimFailed = 'founder_market_deal_claim_failed',
  CRMCreateCustomFieldFailed = 'crm_create_custom_field_failed',
  CRMCreateCustomFieldSuccessful = 'crm_create_custom_field_successful',
  CRMUpdateCustomFieldFailed = 'crm_update_custom_field_failed',
  CRMUpdateCustomFieldSuccessful = 'crm_update_custom_field_successful',
  CRMDeleteCustomFieldFailed = 'crm_delete_custom_field_failed',
  CRMDeleteCustomFieldSuccessful = 'crm_delete_custom_field_successful',
  ExportAllInvestorUsersSuccessful = 'export_all_investor_users_successful',
  ExportAllInvestorUsersFailed = 'export_all_investor_users_failed',
  CRMUpdateColumnIndexSuccessful = 'crm_update_column_index_successful',
  CRMUpdateColumnIndexFailed = 'crm_update_column_index_failed',
  CRMUpdateActiveRoundInCompanySuccessful = 'crm_update_active_round_in_company_successful',
  CRMUpdateActiveRoundInCompanyFailed = 'crm_update_active_round_in_company_failed',
  CRMDeleteRoundSuccessful = 'crm_delete_round_successful',
  CRMDeleteRoundFailed = 'crm_delete_round_failed',
  CRMCreateInvestorFromCsvSuccessful = 'crm_create_investor_from_csv_successful',
  CRMCreateInvestorFromCsvFailed = 'crm_create_investor_from_csv_failed',
  CRMInvestmentTransactionRejectSuccessful = 'crm_investment_transaction_reject_successful',
  CRMInvestmentTransactionRejectionFailed = 'crm_investment_transaction_rejection_failed',
  CRMInvestmentTransactionSuccessful = 'crm_investment_transaction_successfull',
  CRMInvestmentTransactionFailed = 'crm_investment_transaction_failed',
  CRMEditActivitySuccessful = 'crm_edit_activity_successful',
  CRMEditActivityFailed = 'crm_edit_activity_failed',
  CRMCreateRoundSuccessful = 'crm_create_round_successful',
  CRMCreateRoundFailed = 'crm_create_round_failed',
  CRMUpdateRoundSuccessful = 'crm_update_round_successful',
  CRMUpdateRoundFailed = 'crm_update_round_failed',
  CRMAddInvestorContactSuccessful = 'crm_add_investor_contact_successful',
  CRMAddInvestorContactFailed = 'crm_add_investor_contact_failed',
  CRMUpdateInvestorColumnFailed = 'crm_update_investor_column_failed',
  CRMUpdateInvestorColumnSuccessful = 'crm_update_investor_column_successful',
  CRMAddFavInvestorFailed = 'crm_add_favourite_investor_failed',
  CRMAddFavInvestorSuccessful = 'crm_add_favourite_investor_successful',
  CRMRemoveFavInvestorSuccessful = 'crm_remove_favourite_investor_successful',
  CRMDeleteColumnSuccessful = 'crm_delete_column_successful',
  CRMDeleteColumnFailed = 'crm_delete_column_failed',
  CRMDeleteInvestorUserColumnFailed = 'crm_delete_investor_user_column_failed',
  CRMDeleteInvestorUserColumnSuccessful = 'crm_delete_investor_user_column_successful',
  CRMInvestorUserDeleteSuccessful = 'crm_investor_user_delete_successful',
  CRMInvestorUserDeleteFailed = 'crm_investor_user_delete_failed',
  CRMEditColumnSuccessful = 'crm_edit_column_successful',
  CRMEditColumnFailed = 'crm_edit_column_failed',
  CRMAddColumnSuccessful = 'crm_add_column_successful',
  CRMAddColumnFailed = 'crm_add_column_failed',
  CRMActivityCsvExportSuccessful = 'crm_activity_csv_export_successful',
  CRMActivityCsvExportFailed = 'crm_activity_csv_export_failed',
  CRMDeleteActivitySuccessful = 'crm_delete_activity_successful',
  CRMDeleteActivityFailed = 'crm_delete_activity_failed',
  CRMSignedFileDownloadSuccessful = 'crm_signed_file_download_successful',
  CRMCreateActivitySuccessful = 'crm_create_activity_successful',
  CRMCreateActivityFailed = 'crm_create_activity_failed',
  CRMAddNewInvestorUserSuccessful = 'crm_add_new_investor_user_successful',
  CRMAddNewInvestorUserFailed = 'crm_add_new_investor_user_failed',
  AddFavInvestorFailed = 'add_favourite_investor_failed',
  AddFavInvestorSuccessful = 'add_favourite_investor_successful',
  CreateErrorReportSuccessful = 'create_error_report_successful',
  CreateErrorReportFailed = 'create_error_report_failed',
  CRMInvestorUserAddedSuccessful = 'crm_investor_user_added_successful',
  CRMInvestorUserAddedFailed = 'crm_investor_user_added_failed',
  UpdateInvestorTwitterUrlFailed = 'update_investor_twitter_url_failed',
  UpdateInvestorTwitterUrlSuccessful = 'update_investor_twitter_url_successful',
  InvestorOverviewDataAddedFailed = 'investor_overview_data_added_failed',
  InvestorOverviewDataAddedSuccessful = 'investor_overview_data_added_successful',
  UpdateInvestorFailed = 'update_investor_failed',
  UpdateInvestorSuccessful = 'update_investor_successful',
  UpdateInvestorInvestmentsFailed = 'update_investor_investments_failed',
  UpdateInvestorInvestmentsSuccessful = 'update_investor_investments_successful',
  AddInvestorSuccessful = 'add_investor_successful',
  AddInvestorFailed = 'add_investor_failed',
  AddInvestorInvestmentSuccessful = 'add_investor_investment_successful',
  AddInvestorInvestmentFailed = 'add_investor_investment_failed',
  DownloadSignedFileSuccessful = 'download_signed_file_successful',
  DeleteTemplateSuccessful = 'delete_template_successful',
  DeleteTemplateFailed = 'delete_template_failed',
  CopyTemplateFailed = 'copy_template_failed',
  CopyTemplateSuccessful = 'copy_template_successful',
  EditEmailDraftFailed = 'edit_email_draft_failed',
  EditEmailDraftSuccessful = 'edit_email_draft_successful',
  SaveEmailDraftFailed = 'save_email_draft_failed',
  SaveEmailDraftSuccessful = 'save_email_draft_successful',
  SendBulkEmailsFailed = 'send_bulk_emails_failed',
  SendBulkEmailsSuccessful = 'send_bulk_emails_successful',
  SendTestEmailFailed = 'send_test_email_failed',
  SendTestEmailSuccessful = 'send_test_email_successful',
  EditInvestorUpdatesStatusFailed = 'edit_investor_updates_status_failed',
  EditInvestorUpdatesStatusSuccessful = 'edit_investor_updates_status_successful',
  DeleteInvestorUpdatesFailed = 'delete_investor_updates_failed',
  DeleteInvestorUpdatesSuccessful = 'delete_investor_updates_successful',
  CreatePitchDeckFailed = 'create_pitch_deck_failed',
  CreatePitchDeckSuccessful = 'create_pitch_deck_successful',
  DeletePitchDeckSuccessful = 'delete_pitch_deck_successful',
  DeletePitchDeckFailed = 'delete_pitch_deck_failed',
  UpdatePitchDeckStatusSuccessful = 'update_pitch_deck_status_successful',
  UpdatePitchDeckStatusFailed = 'update_pitch_deck_status_failed',
  CreateEmailCopySuccessful = 'create_email_copy_successful',
  CreateEmailCopyFailed = 'create_email_copy_failed',
  UpdateTemplateSuccessful = 'update_template_successful',
  UpdateTemplateFailed = 'update_template_failed',
  TemplateDraftSavedSuccessful = 'template_draft_saved_successful',
  TemplateDraftSavedFailed = 'template_draft_saved_failed',
  TemplatePublishedSuccessful = 'template_published_successful',
  TemplatePublishedFailed = 'template_published_failed',
  CreateInvestorUpdateSuccessful = 'create_investor_update_successful',
  CreateInvestorUpdateFailed = 'create_investor_update_failed',
  EditInvestorUpdatesFailed = 'edit_investor_updates_failed',
  EditInvestorUpdatesSuccessful = 'edit_investor_updates_successful',
  CreateCopyInvestorUpdatesSuccessful = 'create_copy_investor_updates_successful',
  CreateCopyInvestorUpdatesFailed = 'create_copy_investor_updates_failed',
  AddUserSuccessful = 'add_user_successful',
  AddUserFailed = 'add_user_failed',
  EditUserSuccessful = 'edit_user_successful',
  EditUserFailed = 'edit_user_failed',
  ForgotPasswordSuccessful = 'forgot_password_successful',
  ForgotPasswordFailed = 'forgot_password_failed',
  DisconnectNylasSuccessful = 'disconnect_nylas_successful',
  DisconnectNylasFailed = 'disconnect_nylas_failed',
  CreateSenderProfileInfoSuccessful = 'create_sender_profile_info_successful',
  CreateSenderProfileInfoFailed = 'create_sender_profile_info_failed',
  UpdateTransferOwnershipSuccessful = 'update_transfer_ownership_successful',
  UpdateTransferOwnershipFailed = 'update_transfer_ownership_failed',
  DeleteUserFailed = 'delete_user_failed',
  DeleteUserSuccessful = 'delete_user_successful',
  DeleteInviteFailed = 'delete_invite_failed',
  DeleteInviteSuccessful = 'delete_invite_successful',
  UpdatePaypalReferralEmailFailed = 'update_paypal_referral_email_failed',
  UpdatePaypalReferralEmailSuccessful = 'update_paypal_referral_email_successful',
  UpdateUserOtherSettingsSuccessful = 'update_user_other_settings_successful',
  UpdateUserOtherSettingsFailed = 'update_user_other_settings_failed',
  CreateEmailPreferencesSuccessful = 'create_email_preferences_successful',
  CreateEmailPreferencesFailed = 'create_email_preferences_failed',
  UpdateCompanyOtherSettingsSuccessful = 'update_company_other_settings_successful',
  UpdateCompanyOtherSettingsFailed = 'update_company_other_settings_failed',
  CreateLocaleSuccessful = 'create_locale_successful',
  CreateLocaleFailed = 'create_locale_failed',
  UpdateMailerActiveSuccessful = 'update_mailer_active_successful',
  UpdateMailerActiveFailed = 'update_mailer_active_failed',
  CreatePostmarkMailSuccessful = 'create_postmark_mail_successful',
  CreatePostmarkMailFailed = 'create_postmark_mail_failed',
  CreateSendgridMailSuccessful = 'create_sendgrid_mail_successful',
  CreateSendgridMailFailed = 'create_sendgrid_mail_failed',
  CreateCustomSmtpMailSuccessful = 'create_custom_smtp_mail_successful',
  CreateCustomSmtpMailFailed = 'create_custom_smtp_mail_failed',
  SendTestMailSuccessful = 'send_test_mail_successful',
  SendTestMailFailed = 'send_test_mail_failed',
  RedirectedToNylasSuccessful = 'redirected_to_nylas_successful',
  RedirectedToNylasFailed = 'redirected_to_nylas_failed',
  ShareSocialMedia = 'share_social_media',
  ShareholderDetailsPageAccessSuccessful = 'shareholder_details_page_access_successful',
  ShareholderDetailsPageAccessFailed = 'shareholder_details_page_access_failed',
  ShareholderCreationDocumentsUploadSuccessful = 'shareholder_creation_documents_upload_successful',
  ShareholderCreationDocumentsUploadFailed = 'shareholder_creation_documents_upload_failed',
  ShareholderCreationPersonalDocumentsPageAccessSuccessful = 'shareholder_creation_personal_documents_page_access_successful',
  ShareholderUpdationSuccessful = 'shareholder_updation_successful',
  ShareholderUpdationFailed = 'shareholder_updation_failed',
  ShareholderCreationSuccessful = 'shareholder_creation_successful',
  ShareholderCreationFailed = 'shareholder_creation_failed',
  ShareholderCreationPersonalDetailsPageAccessSuccessful = 'shareholder_creation_personal_details_page_access_successful',
  ShareholderCreationPersonalAddressPageAccessSuccessful = 'shareholder_creation_personal_address_page_access_successful',
  ShareholderCreationPersonalOtherDetailsPageAccessSuccessful = 'shareholder_creation_personal_other_details_page_access_successful',
  ShareholderCreationPictureUploadSuccessful = 'shareholder_creation_picture_upload_successful',
  ShareholderCreationPictureUploadFailed = 'shareholder_creation_picture_upload_failed',
  ShareSecurityClassExportedSuccessful = 'shareholder_share_security_class_exported_successful',
  ShareSecurityClassExportedFailed = 'shareholder_share_security_class_exported_failed',
  ConvertibleSecurityClassExportedSuccessful = 'shareholder_convertible_security_class_exported_successful',
  ConvertibleSecurityClassAccessSuccessful = 'shareholder_convertible_security_class_access_successful',
  ConvertibleSecurityClassAccessFailed = 'shareholder_convertible_security_class_access_failed',
  ConvertibleSecurityClassUpdateSuccessful = 'shareholder_convertible_security_class_update_successful',
  ConvertibleSecurityClassUpdateFailed = 'shareholder_convertible_security_class_update_failed',
  ConvertibleSecurityClassAddSuccessful = 'shareholder_convertible_security_class_add_successful',
  ConvertibleSecurityClassAddFailed = 'shareholder_convertible_security_class_add_failed',
  ConvertibleSecurityClassExportedFailed = 'shareholder_convertible_security_class_exported_failed',
  WarrantSecurityClassExportedSuccessful = 'shareholder_warrant_security_class_exported_successful',
  WarrantSecurityClassExportedFailed = 'shareholder_warrant_security_class_exported_failed',
  AddWarrantSecurityClassSuccessful = 'shareholder_warrant_security_class_add_successful',
  AddWarrantSecurityClassFailed = 'shareholder_warrant_security_class_add_failed',
  UpdateWarrantSecurityClassSuccessful = 'shareholder_warrant_security_class_update_successful',
  UpdateWarrantSecurityClassFailed = 'shareholder_warrant_security_class_update_failed',
  ImportFounderPromotersCsvSuccessful = 'shareholder_founder_promoters_csv_imported_successful',
  ImportFounderPromotersCsvFailed = 'shareholder_founder_promoters_csv_imported_failed',
  ExportFounderPromotersDocumentSuccessful = 'shareholder_founder_promoters_document_exported_successful',
  ExportFounderPromotersDocumentFailed = 'shareholder_founder_promoters_document_exported_failed',
  ShareholderDeletionSuccessful = 'shareholder_deletion_successful',
  ShareholderDeletionFailed = 'shareholder_deletion_failed',
  ImportBoardMemberFailed = 'import_board_member_failed',
  ImportBoardMemberSuccessful = 'import_board_member_successful',
  DeleteBoardMemberSuccessful = 'board_member_deleted_successful',
  BoardMemberDetailsAccessSuccessful = 'board_member_details_access_successful',
  BoardMemberDetailsAccessFailed = 'board_member_details_access_failed',
  BoardMemberCreateOrUpdateDocumentsUploadSuccessful = 'board_member_create_or_update_documents_upload_successful',
  BoardMemberCreateOrUpdateDocumentsUploadFailed = 'board_member_create_or_update_documents_upload_failed',
  DeleteBoardMemberFailed = 'board_member_deleted_failed',
  ExportBoardMemberFailed = 'export_board_member_failed',
  ExportBoardMemberSuccessful = 'export_board_member_successful',
  BoardMembersCreationSuccessful = 'board_members_creation_successful',
  BoardMembersCreationFailed = 'board_members_creation_failed',
  BoardMembersUpdationSuccessful = 'board_members_updation_successful',
  BoardMembersUpdationFailed = 'board_members_updation_failed',
  BoardMemberAccessSuccessful = 'board_member_access_successful',
  BoardMemberAccessFailed = 'board_member_access_failed',
  UpdateProfessionalExpSuccessful = 'update_professional_experience_successful',
  CreateProfessionalExpSuccessful = 'create_professional_experience_successful',
  CreateProfessionalExpFailed = 'create_professional_experience_failed',
  UpdateFounderPromoterSuccessful = 'update_founder_promoters_successful',
  UpdateFounderPromoterFailed = 'update_shareholder_founder_promoters_failed',
  CreateFounderPromoterSuccessful = 'founder_promoters_creation_successful',
  CreateFounderPromoterFailed = 'founder_promoters_creation_failed',
  DeleteFounderPromoterSuccessful = 'founder_promoters_deletion_successful',
  DeleteFounderPromoterFailed = 'founder_promoters_deletion_failed',
  ExportFounderPromoterFailed = 'export_founder_promoter_failed',
  ExportFounderPromoterSuccessful = 'export_founder_promoter_successful',
  ImportFounderPromoterSuccessful = 'import_founder_promoter_successful',
  ImportFounderPromoterFailed = 'import_founder_promoter_failed',
  FounderPromoterDetailsAccessSuccessful = 'founder_promoters_details_access_successful',
  FounderPromoterDetailsAccessFailed = 'founder_promoters_details_access_failed',
  FoundersPromoterAccessSuccessful = 'founders_promoters_access_successful',
  FoundersPromoterAccessFailed = 'founders_promoters_access_failed',
  UpdateTeamMemberSuccessful = 'management_team_updation_successful',
  UpdateTeamMemberFailed = 'management_team_updation_failed',
  TeamMemberAccessSuccessful = 'management_team_access_successful',
  TeamMemberAccessFailed = 'management_team_access_failed',
  AddTeamMemberSuccessful = 'management_team_creation_successful',
  AddTeamMemberFailed = 'management_team_creation_failed',
  TeamMemberDetailsAccessSuccessful = 'management_team_details_access_successful',
  TeamMemberDetailsAccessFailed = 'management_team_details_access_failed',
  ExportTeamManagementFailed = 'export_team_management_failed',
  ExportTeamManagementSuccessful = 'export_team_management_successful',
  ImportTeamManagementFailed = 'import_team_management_failed',
  ImportTeamManagementSuccessful = 'import_team_management_successful',
  DeleteTeamMemberSuccessful = 'management_team_deletion_successful',
  DeleteTeamMemberFailed = 'management_team_deletion_failed',
  DeleteDocumentFailed = 'delete_document_failed',
  DeleteDocumentSuccessful = 'delete_document_successful',
  DownloadDocumentSuccessful = 'download_document_successful',
  DownloadDocumentFailed = 'download_document_failed',
  DocumentUploadedSuccessful = 'document_uploaded_successful',
  DocumentUploadedFailed = 'document_uploaded_failed',
  AddShareSecurityClassSuccessful = 'share_security_class_creation_successful',
  AddShareSecurityClassFailed = 'share_security_class_creation_failed',
  ShareSecurityClassUpdateFailed = 'share_security_class_update_failed',
  ShareSecurityClassUpdateSuccessful = 'share_security_class_update_successful',
  DeleteLegalMemberSuccessful = 'legal_member_deleted_successful',
  DeleteLegalMemberFailed = 'legal_member_deleted_failed',
  ExportLegalCompilanceSuccessful = 'legal_compilance_exported_successful',
  ExportLegalCompilanceFailed = 'legal_compilance_exported_failed',
  LegalMemberDetailsAccessSuccessful = 'legal_member_details_access_successful',
  LegalMemberDetailsAccessFailed = 'legal_member_details_access_failed',
  ImportLegalCompilanceSuccessful = 'legal_compilance_imported_successful',
  ImportLegalCompilanceFailed = 'legal_compilance_imported_failed',
  AddLegalCompilanceSuccessful = 'legal_compilance_creation_successful',
  AddLegalCompilanceFailed = 'legal_compilance_creation_failed',
  UpdateLegalCompilanceSuccessful = 'legal_compilance_update_successful',
  UpdateLegalCompilanceFailed = 'legal_compilance_update_failed',
  LegalCompilanceAccessSuccessful = 'legal_compilance_access_successful',
  LegalCompilanceAccessFailed = 'legal_compilance_access_failed',
  LegalComplianceDetailsAccessSuccessful = 'legal_compilance_details_access_successful',
  LegalComplianceDetailsAccessFailed = 'legal_compilance_details_access_failed',
  AddAdvisorsMentorsSuccessful = 'advisors_mentors_creation_successful',
  AddAdvisorsMentorsFailed = 'advisors_mentors_creation_failed',
  UpdateAdvisorsMentorsSuccessful = 'advisors_mentors_update_successful',
  UpdateAdvisorsMentorsFailed = 'advisors_mentors_update_failed',
  AdvisorsMentorsDetailsAccessSuccessful = 'advisors_mentors_details_access_successful',
  AdvisorsMentorsDetailsAccessFailed = 'advisors_mentors_details_access_failed',
  DeleteAdvisorMentorSuccessful = 'advisor_mentor_deleted_successful',
  DeleteAdvisorMentorFailed = 'advisor_mentor_deleted_failed',
  AdvisorMentorAccessSuccessful = 'advisor_mentor_access_successful',
  AdvisorMentorAccessFailed = 'advisor_mentor_access_failed',
  ExportAdvisorMentorSuccessful = 'advisor_mentor_exported_successful',
  ExportAdvisorMentorFailed = 'advisor_mentor_exported_failed',
  ImportAdvisorMentorSuccessful = 'advisor_mentor_imported_successful',
  ImportAdvisorMentorFailed = 'advisor_mentor_imported_failed',
  AddFinanceAccountsSuccessful = 'finance_accounts_creation_successful',
  AddFinanceAccountsFailed = 'finance_accounts_creation_failed',
  UpdateFinanceAccountsSuccessful = 'finance_accounts_update_successful',
  UpdateFinanceAccountsFailed = 'finance_accounts_update_failed',
  FinanceAccountsDetailsAccessSuccessful = 'finance_accounts_details_access_successful',
  FinanceAccountsDetailsAccessFailed = 'finance_accounts_details_access_failed',
  FinanceAccountsAccessSuccessful = 'finance_accounts_access_successful',
  FinanceAccountsAccessFailed = 'finance_accounts_access_failed',
  ExportFinanceAccountsSuccessful = 'finance_accounts_exported_successful',
  ExportFinanceAccountsFailed = 'finance_accounts_exported_failed',
  ImportFinanceAccountsSuccessful = 'finance_accounts_imported_successful',
  ImportFinanceAccountsFailed = 'finance_accounts_imported_failed',
  DeleteFinanceAccountsSuccessful = 'finance_accounts_deleted_successful',
  DeleteFinanceAccountsFailed = 'finance_accounts_deleted_failed',

  AddShareTransactionSuccessful = 'share_transaction_creation_successful',
  AddShareTransactionFailed = 'share_transaction_creation_failed',
  UpdateShareTransactionSuccessful = 'share_transaction_update_successful',
  UpdateShareTransactionFailed = 'share_transaction_update_failed',
  DeleteShareTransactionSuccessful = 'share_transaction_deletion_successful',
  DeleteShareTransactionFailed = 'share_transaction_deletion_failed',
  ShareTransactionDetailsAccessSuccessful = 'share_transaction_details_access_successful',
  ShareTransactionDetailsAccessFailed = 'share_transaction_details_access_failed',
  ShareTransactionAccessSuccessful = 'share_transaction_access_successful',
  ShareTransactionAccessFailed = 'share_transaction_access_failed',
  ExportShareTransactionSuccessful = 'share_transaction_exported_successful',
  ExportShareTransactionFailed = 'share_transaction_exported_failed',

  AddConvertibleTransactionSuccessful = 'convertible_transaction_creation_successful',
  AddConvertibleTransactionFailed = 'convertible_transaction_creation_failed',
  UpdateConvertibleTransactionSuccessful = 'convertible_transaction_update_successful',
  UpdateConvertibleTransactionFailed = 'convertible_transaction_update_failed',
  DeleteConvertibleTransactionSuccessful = 'convertible_transaction_deletion_successful',
  DeleteConvertibleTransactionFailed = 'convertible_transaction_deletion_failed',
  ConvertibleTransactionDetailsAccessSuccessful = 'convertible_transaction_details_access_successful',
  ConvertibleTransactionDetailsAccessFailed = 'convertible_transaction_details_access_failed',
  ConvertibleTransactionAccessSuccessful = 'convertible_transaction_access_successful',
  ConvertibleTransactionAccessFailed = 'convertible_transaction_access_failed',
  ExportConvertibleTransactionSuccessful = 'convertible_transaction_exported_successful',
  ExportConvertibleTransactionFailed = 'convertible_transaction_exported_failed',

  AddWarrantTransactionSuccessful = 'warrant_transaction_creation_successful',
  AddWarrantTransactionFailed = 'warrant_transaction_creation_failed',
  UpdateWarrantTransactionSuccessful = 'warrant_transaction_update_successful',
  UpdateWarrantTransactionFailed = 'warrant_transaction_update_failed',
  DeleteWarrantTransactionSuccessful = 'warrant_transaction_deletion_successful',
  DeleteWarrantTransactionFailed = 'warrant_transaction_deletion_failed',

  AddBuybackTransactionSuccessful = 'buyback_transaction_creation_successful',
  AddBuybackTransactionFailed = 'buyback_transaction_creation_failed',
  UpdateBuybackTransactionSuccessful = 'buyback_transaction_update_successful',
  UpdateBuybackTransactionFailed = 'buyback_transaction_update_failed',
  BuybackTransactionAccessSuccessful = 'buyback_transaction_access_successful',
  BuybackTransactionAccessFailed = 'buyback_transaction_access_failed',
  DeleteBuybackTransactionSuccessful = 'buyback_transaction_deletion_successful',
  DeleteBuybackTransactionFailed = 'buyback_transaction_deletion_failed',

  TransferTransactionAccessSuccessful = 'transfer_transaction_access_successful',
  TransferTransactionAccessFailed = 'transfer_transaction_access_failed',
  AddTransferTransactionSuccessful = 'transfer_transaction_creation_successful',
  AddTransferTransactionFailed = 'transfer_transaction_creation_failed',
  UpdateTransferTransactionSuccessful = 'transfer_transaction_update_successful',
  UpdateTransferTransactionFailed = 'transfer_transaction_update_failed',
  DeleteTransferTransactionSuccessful = 'transfer_transaction_deletion_successful',
  DeleteTransferTransactionFailed = 'transfer_transaction_deletion_failed',

  BoardMemberSearchSuccessful = 'board_member_search_successful',
  FounderPromoterSearchSuccessful = 'founder_promoter_search_successful',
  AdvisorMentorSearchSuccessful = 'advisor_mentor_search_successful',
  FinanceAccountsSearchSuccessful = 'finance_accounts_search_successful',
  LegalComplianceSearchSuccessful = 'legal_compilance_search_successful',
  TeamManagementSearchSuccessful = 'team_management_search_successful',

  BoardMemberFilterAppliedSuccessful = 'board_member_filter_applied_successful',
  BoardMemberFilterRemovedSuccessful = 'board_member_filter_removed_successful',
  FounderPromoterFilterAppliedSuccessful = 'founder_promoter_filter_applied_successful',
  FounderPromoterFilterRemovedSuccessful = 'founder_promoter_filter_removed_successful',
  AdvisorMentorFilterAppliedSuccessful = 'advisor_mentor_filter_applied_successful',
  AdvisorMentorFilterRemovedSuccessful = 'advisor_mentor_filter_removed_successful',
  FinanceAccountsFilterAppliedSuccessful = 'finance_accounts_filter_applied_successful',
  FinanceAccountsFilterRemovedSuccessful = 'finance_accounts_filter_removed_successful',
  LegalComplianceFilterAppliedSuccessful = 'legal_compilance_filter_applied_successful',
  LegalComplianceFilterRemovedSuccessful = 'legal_compilance_filter_removed_successful',
  TeamManagementFilterAppliedSuccessful = 'team_management_filter_applied_successful',
  TeamManagementFilterRemovedSuccessful = 'team_management_filter_removed_successful',

  ShareSecurityClassFilterAppliedSuccessful = 'share_transaction_filter_applied_successful',
  ShareSecurityClassFilterRemovedSuccessful = 'share_security_class_filter_removed_successful',
  ConvertibleSecurityClassFilterAppliedSuccessful = 'convertible_security_class_filter_applied_successful',
  ConvertibleSecurityClassFilterRemovedSuccessful = 'convertible_security_class_filter_removed_successful',
  WarrantSecurityClassFilterAppliedSuccessful = 'warrant_security_class_filter_applied_successful',
  WarrantSecurityClassFilterRemovedSuccessful = 'warrant_security_class_filter_removed_successful',

  ShareSecurityClassSearchSuccessful = 'share_security_class_search_successful',
  ConvertibleSecurityClassSearchSuccessful = 'convertible_security_class_search_successful',
  WarrantSecurityClassSearchSuccessful = 'warrant_security_class_search_successful',

  ShareTransactionFilterAppliedSuccessful = 'share_transaction_filter_applied_successful',
  ShareTransactionFilterRemovedSuccessful = 'share_transaction_filter_removed_successful',
  ConvertibleTransactionFilterAppliedSuccessful = 'convertible_transaction_filter_applied_successful',
  ConvertibleTransactionFilterRemovedSuccessful = 'convertible_transaction_filter_removed_successful',
  WarrantTransactionFilterAppliedSuccessful = 'warrant_transaction_filter_applied_successful',
  WarrantTransactionFilterRemovedSuccessful = 'warrant_transaction_filter_removed_successful',
  BuybackTransactionFilterAppliedSuccessful = 'buyback_transaction_filter_applied_successful',
  BuybackTransactionFilterRemovedSuccessful = 'buyback_transaction_filter_removed_successful',
  TransferTransactionFilterAppliedSuccessful = 'transfer_transaction_filter_applied_successful',
  TransferTransactionFilterRemovedSuccessful = 'transfer_transaction_filter_removed_successful',

  ShareTransactionSearchSuccessful = 'share_transaction_search_successful',
  ConvertibleTransactionSearchSuccessful = 'convertible_transaction_search_successful',
  WarrantTransactionSearchSuccessful = 'warrant_transaction_search_successful',
  BuybackTransactionSearchSuccessful = 'buyback_transaction_search_successful',
  TransferTransactionSearchSuccessful = 'transfer_transaction_search_successful',
  BuybackManualMethodSearchSuccessful = 'buyback_manual_method_search_successful',

  ShareSecurityClassCreateOrUpdateDocumentsUploadSuccessful = 'share_security_class_create_or_update_documents_upload_successful',
  ShareSecurityClassCreateOrUpdateDocumentsUploadFailed = 'share_security_class_create_or_update_documents_upload_failed',
  ConvertibleSecurityClassCreateOrUpdateDocumentsUploadSuccessful = 'convertible_security_class_create_or_update_documents_upload_successful',
  ConvertibleSecurityClassCreateOrUpdateDocumentsUploadFailed = 'convertible_security_class_create_or_update_documents_upload_failed',
  WarrantSecurityClassCreateOrUpdateDocumentsUploadSuccessful = 'warrant_security_class_create_or_update_documents_upload_successful',
  WarrantSecurityClassCreateOrUpdateDocumentsUploadFailed = 'warrant_security_class_create_or_update_documents_upload_failed',

  ShareTransactionCreateOrUpdateDocumentsUploadSuccessful = 'share_transaction_create_or_update_documents_upload_successful',
  ShareTransactionCreateOrUpdateDocumentsUploadFailed = 'share_transaction_create_or_update_documents_upload_failed',
  ConvertibleTransactionCreateOrUpdateDocumentsUploadSuccessful = 'convertible_transaction_create_or_update_documents_upload_successful',
  ConvertibleTransactionCreateOrUpdateDocumentsUploadFailed = 'convertible_transaction_create_or_update_documents_upload_failed',
  WarrantTransactionCreateOrUpdateDocumentsUploadSuccessful = 'warrant_transaction_create_or_update_documents_upload_successful',
  WarrantTransactionCreateOrUpdateDocumentsUploadFailed = 'warrant_transaction_create_or_update_documents_upload_failed',
  BuybackTransactionCreateOrUpdateDocumentsUploadSuccessful = 'buyback_transaction_create_or_update_documents_upload_successful',
  BuybackTransactionCreateOrUpdateDocumentsUploadFailed = 'buyback_transaction_create_or_update_documents_upload_failed',
  TransferTransactionCreateOrUpdateDocumentsUploadSuccessful = 'transfer_transaction_create_or_update_documents_upload_successful',
  TransferTransactionCreateOrUpdateDocumentsUploadFailed = 'transfer_transaction_create_or_update_documents_upload_failed',

  ResourcesDownloaded = 'resources_downloaded',
  ResourcesDownloadFailed = 'resources_download_failed',
  ContactUpdateSuccessful = 'shared_access_contact_updated_successful',
  ContactCreateSuccessful = 'shared_access_contact_created_successful',
  ContactCreationFailed = 'shared_access_contact_creation_failed',
  ContactCreateOrUpdateFailed = 'shared_access_contact_create_or_update_failed',
  SharedAccessEmailDeleteFailed = 'shared_access_email_delete_failed',
  SharedAccessEmailDeleteSuccessful = 'shared_access_email_delete_successful',
  SharedAccessEmailStarredFailed = 'shared_access_email_starred_failed',
  SharedAccessEmailStarredSuccessful = 'shared_access_email_starred_successful',
  SharedAccessEmailSentSuccessful = 'shared_access_email_sent_successful',
  SharedAccessEmailSentFailed = 'shared_access_email_sent_failed',
  SharedAccessEmailUpdateFailed = 'shared_access_email_update_failed',
  SharedAccessEmailUpdatedSuccessful = 'shared_access_email_updated_successful',
  SharedAccessEmailDeletedSuccessful = 'shared_access_email_deleted_successful',
  DeleteContactSuccessful = 'shared_access_contact_deleted_successful',
  DeleteContactFailed = 'shared_access_contact_delete_failed',
  SharedAccessEmailSavedAsDraftSuccessful = 'shared_access_email_saved_as_draft_successful',
  SharedAccessEmailSavedAsDraftFailed = 'shared_access_email_saved_as_draft_failed',
  SharedAccessEventCreateSuccessful = 'shared_access_event_create_successful',
  SharedAccessEventCreateFailed = 'shared_access_event_create_failed',
  SharedAccessEventUpdatedSuccessful = 'shared_access_event_updated_successful',
  SharedAccessEventDeletedSuccessful = 'shared_access_event_deleted_successful',
  SharedAccessEventDeleteFailed = 'shared_access_event_delete_failed',
  ContactDeletedSuccessful = 'shared_access_contact_deleted_successful',
  ContactDeleteFailed = 'shared_access_contact_delete_failed',
  AgendaCreatedSuccessful = 'agenda_created_successful',
  AgendaCreateFailed = 'agenda_create_failed',
  AgendaUpdatedSuccessful = 'agenda_updated_successful',
  AgendaUpdateFailed = 'agenda_update_failed',
  AgendaDeletedSuccessful = 'agenda_deleted_successful',
  AgendaDeleteFailed = 'agenda_delete_failed',
  ParticipantAddedSuccessful = 'participant_added_successful',
  ParticipantAddedFailed = 'participant_add_failed',
  ParticipantUpdatedSuccessful = 'participant_updated_successful',
  ParticipantUpdateFailed = 'participant_update_failed',
  ParticipantDeletedSuccessful = 'participant_deleted_successful',
  ParticipantDeleteFailed = 'participant_delete_failed',
  CreateBoardMeetingInitiationSuccessful = 'create_board_meeting_initiation_successful',
  CreateBoardMeetingInitiationFailed = 'create_board_meeting_initiation_failed',
  CreateBoardMeetingSuccessful = 'create_board_meeting_successful',
  CreateBoardMeetingFailed = 'create_board_meeting_failed',
  UpdateBoardMeetingInitiationSuccessful = 'board_meeting_updated_successful',
  UpdateBoardMeetingInitiationFailed = 'board_meeting_update_failed',
  BoardMeetingCancelledSuccessful = 'board_meeting_cancelled_successful',
  BoardMeetingCancelFailed = 'board_meeting_cancel_failed',
  FileRemovedSuccessful = 'file_removed_successful',
  MeetingSummaryCreateSuccessful = 'meeting_summary_created_successful',
  MeetingSummaryCreateFailed = 'meeting_summary_create_failed',
  MeetingSummaryUpdatedSuccessful = 'meeting_summary_updated_successful',
  MeetingSummaryUpdateFailed = 'meeting_summary_update_failed',
  MeetingExportCsvSuccessful = 'meeting_export_csv_successful',
  MeetingExportCsvFailed = 'meeting_export_csv_failed',
  DuplicateMeetingCreateSuccessful = 'duplicate_meeting_created_successful',
  DuplicateMeetingCreateFailed = 'duplicate_meeting_create_failed',
  FileUploadSuccessful = 'file_upload_successful',
  FileUploadFailed = 'file_upload_failed',
  TranscriptSuccessfully = 'transcript_successful',
  TranscriptFailed = 'transcript_failed',
  EarlyAdopterFormInitiatedSuccessful = 'early_adopter_form_initiated_successful',
  EarlyAdopterFormSubmitSuccessful = 'early_adopter_form_submit_successful',
  EarlyAdopterFormSubmitFailed = 'early_adopter_form_submit_failed',
  LandingPageViewSuccessful = 'landing_page_view_successful',
  SubscriptionUpgraded = 'subscription_upgraded',
  SubscriptionDowngraded = 'subscription_downgraded',
  UpgradeModalOpened = 'upgrade_modal_opened',
  UpgradeModalClosed = 'upgrade_modal_closed',
  PhoneVerificationStartSuccessful = 'phone_verification_start_successful',
  PhoneVerificationStartFailed = 'phone_verification_start_failed',
  PhoneVerificationSuccessful = 'phone_verification_successful',
  PhoneVerificationFailed = 'phone_verification_failed',
  // UsagePlanScreenShown = 'usage_plan_screen_shown',
  CompanyUsageInfoSuccessful = 'company_and_usage_info_submitted_successful',
}

export const loginSuccessMeta = (user: any, planId?: string, itemPrice?: number) => {
  return {
    user_id: user.userId,
    email: user.email,
    name: `${user?.firstName ?? ''} ${user?.lastName ?? ''}`,
    first_name: user?.firstName,
    last_name: user?.lastName,
    signup_timestamp: new Date(user.createdAt).getTime() / 1000,
    phone:
      user.countryDialingCode && user.contact ? `${user.countryDialingCode}${user.contact}` : null,
    user_hash: user.user_hash,
    profile_image: user.profileImg
      ? `${process.env.REACT_APP_BASE_API_URL}/file/${encodeURIComponent(user.profileImg)}`
      : null,
    utm_source: user.utm_source,
    utm_medium: user.utm_medium,
    utm_campaign: user.utm_campaign,
    utm_content: user.utm_content,
    utm_term: user.utm_term,
    gclid: user.gclid,
    heard_about_us: user?.heardAboutUs ?? null,
    //refered_by: user.firstReferredBy,
    referral_id: user.referCode,
    company_count: user.company.length,
    default_company_id: user?.company?.[0]?.companyId ?? null,
    company: {
      name: user?.company?.[0]?.name,
      company_id: user?.company?.[0]?.companyId,
      created_at: new Date(user?.company?.[0]?.company_user?.createdAt).getTime() / 1000,
      queue_position: user?.company?.[0]?.queuePosition,
      plan: user?.companyPlanStatus?.billing_details?.item_price_id || planId,
      value: itemPrice,
      usage_type: user?.company?.[0]?.useCase,
      for_client_usage: user?.company?.[0]?.forClientUse,
      industry: user?.company?.[0]?.industry,
      team_size: user?.company?.[0]?.teamSize,
      // currency: user?.company?.[0]?.billing_details?.currency_code,
      // value: user?.company?.[0]?.billing_details?.amount / 100,
      // value_in_cents: user?.company?.[0]?.billing_details?.amount,
      // frequency: user?.company?.[0]?.billing_details?.frequency
      //   ? `${user?.company?.[0]?.billing_details?.frequency}ly`
      //   : null,
    },
  }
}

export const loginSuccessMetaWithRound = (user: any, round: any, planId?: string) => {
  let userCompanyObj = loginSuccessMeta(user, planId)
  userCompanyObj.company = {
    ...userCompanyObj.company,
    round: round,
  } as any

  return userCompanyObj
}

export const emailVerificationMeta = (user: any, company?: any) => {
  let data = {
    user_id: user.userId,
    email: user.email,
    name: `${user?.firstName ?? ''} ${user?.lastName ?? ''}`,
    first_name: user?.firstName,
    last_name: user?.lastName,
    signup_timestamp: new Date(user.createdAt).getTime() / 1000,
    phone:
      user.countryDialingCode && user.contact ? `${user.countryDialingCode}${user.contact}` : null,
    user_hash: user.user_hash,
    profile_image: user.profileImg
      ? `${process.env.REACT_APP_BASE_API_URL}/file/${encodeURIComponent(user.profileImg)}`
      : null,
    utm_source: user.utm_source,
    utm_medium: user.utm_medium,
    utm_campaign: user.utm_campaign,
    utm_content: user.utm_content,
    utm_term: user.utm_term,
    gclid: user.gclid,
    //refered_by: user.firstReferredBy,
    referral_id: user.referCode,
    country: countries[user?.countryId]?.country_name,
  }

  if (typeof company !== 'undefined') {
    return {
      ...data,
      company: {
        name: company?.name,
        company_id: company?.companyId,
        plan: company?.planId, //default
        // website: company?.website ?? null,
        // industry: company?.industry,
        created_at: new Date(company?.createdAt).getTime() / 1000,
      },
    }
  } else {
    return data
  }
}

export const baseCompanyMeta = (company: any, count: number) => {
  return {
    company_count: count,
    company: {
      //new company where the user switched
      name: company?.name,
      company_id: company?.companyId,
      plan: company?.planId,
      // website: company?.website,
      // industry: company?.industry,
      created_at: new Date(company.createdAt).getTime() / 1000,
      //monthly_spend: 0,
    },
  }
}

export const companyDetailsMeta = (company: any) => {
  return {
    company: {
      name: company?.name,
      company_id: company?.companyId,
      chargebee_subscription_id: company?.chargebeeSubscriptionId,
      chargebee_customer_id: company?.chargebeeCustomerId,
      profile_image: company?.profileImg
        ? `${process.env.REACT_APP_BASE_API_URL}/file/${encodeURIComponent(company?.profileImg)}`
        : null,
      plan: company?.planId,
      website: company?.website,
      industry: company?.industry,
      tagline: company?.tagline,
      team_size: company?.teamSize,
      legal_name: company?.legalName,
      operating_status: company?.operatingStatus,
      short_description: company?.shortDescription,
      description: company?.description,
      founded_date: company?.foundedDate,
      founders: company?.founders,
      is_active: company?.isActive,
      facebook: company?.facebook,
      linkedin: company?.linkedin,
      twitter: company?.twitter,
      instagram: company?.instagram,
      last_funding_type: company?.lastFundingType,
      operating_countries: company?.operatingCountries,
      published: company?.published,
      slug: company?.slug,
      show_demo_dashboard: company?.showDemoDashboard,
      country: countries[company?.countryId]?.country_name,
      currency: currencies[company?.currencyId]?.code,
      created_at: new Date(company.createdAt).getTime() / 1000,
      queue_position: company?.totalQueueCount,
    },
  }
}

// update utm parameters in local storage
export const updateUTMParameters = (paramName: string, newValue: string) => {
  const existingParam = localStorage.getItem(paramName)

  let paramValue = {firstTouch: newValue, lastTouch: newValue}

  if (existingParam) {
    const existingValue = JSON.parse(existingParam)
    paramValue = {...existingValue, lastTouch: newValue}
    if (!existingValue.firstTouch) {
      paramValue.firstTouch = newValue // Ensure firstTouch is set if it was somehow missing
    }
  }

  localStorage.setItem(paramName, JSON.stringify(paramValue))
}
